import { __assign } from "tslib";
var NON_INDICATOR = function () { return ({}); };
function controlStyle(showWrongState) {
    return function (provided, state) {
        var _a;
        var isFocused = state.isFocused || state.selectProps.isFocusedPhoneNumber;
        var borderColor = 'var(--color-shadow-50)';
        if (showWrongState) {
            borderColor = 'var(--color-danger)';
        }
        else if (state.isDisabled) {
            borderColor = 'var(--color-shadow-30)';
        }
        else if (isFocused || state.hasValue || state.selectProps.phoneNumber) {
            borderColor = 'var(--color-shadow-90) !important';
        }
        var boxShadowColor = 'none';
        if (isFocused) {
            boxShadowColor = showWrongState
                ? 'var(--box-shadow--error)'
                : 'var(--box-shadow--informative)';
        }
        return __assign(__assign(__assign(__assign({}, provided), (_a = {}, _a[state.selectProps.isMulti ? 'minHeight' : 'height'] = '5.6rem', _a.backgroundColor = state.isDisabled ? 'var(--color-shade-10)' : 'initial', _a.flexWrap = 'nowrap', _a.border = "solid .1rem ".concat(borderColor), _a.boxShadow = boxShadowColor, _a['&:hover'] = __assign({}, (showWrongState ? { border: "solid .1rem ".concat(borderColor) } : {})), _a)), (state.selectProps.variant === 'textWithIconLarge'
            ? {
                height: '6.4rem',
                lineHeight: '4.8rem',
                '@media (max-width: 576px)': {
                    height: '4.8rem !important',
                },
            }
            : {})), { svg: {
                color: 'var(--color-shadow-50)',
                marginRight: '.4rem',
            } });
    };
}
export var reactSelectStyle = function (showWrongState) {
    return ({
        control: controlStyle(showWrongState),
        option: function (provided, state) { return (__assign(__assign(__assign({}, provided), { background: state.isSelected ? 'var(--color-informative-10)' : 'initial', color: state.isDisabled ? 'var(--color-shadow-50)' : 'var(--color-shadow-90)' }), (!state.isDisabled
            ? {
                '&:hover': {
                    backgroundColor: 'var(--color-informative-10)',
                },
            }
            : {}))); },
        menuList: function (provided) { return (__assign(__assign({}, provided), { border: 'solid .1rem var(--color-text-headings)', borderRadius: '.4rem' })); },
        menu: function (provided) { return (__assign(__assign({}, provided), { marginTop: '.4rem', boxShadow: 'var(--menu-box-shadow)' })); },
        indicatorSeparator: NON_INDICATOR,
        singleValue: function (style, state) { return (__assign(__assign({}, style), { color: state.isDisabled ? 'var(--color-shadow-30)' : 'var(--color-shadow-90)', marginRight: '-5rem', marginLeft: '.5rem' })); },
        placeholder: function (provided, state) { return (__assign(__assign({}, provided), { color: state.isDisabled ? 'var(--color-shadow-30)' : 'var(--color-shadow-50)', fontSize: 'var(--font-size--md)', flexBasis: 'fit-content', marginRight: '-5rem', marginLeft: '.5rem' })); },
        input: function (provided) { return (__assign(__assign({}, provided), { padding: '1rem .4rem' })); },
        valueContainer: function (style) { return (__assign(__assign({}, style), { flexBasis: 'fit-content' })); },
        noOptionsMessage: function (style) { return (__assign(__assign({}, style), { display: 'flex', justifyContent: 'flex-start' })); },
        menuPortal: function (style) { return (__assign(__assign({}, style), { zIndex: 9999 })); },
    });
};
//# sourceMappingURL=selectStyles.js.map